module.exports = __webpack_public_path__ + "assets/861a7fc581b3235259635e0da4dafe84.png";